@for (policy of policies; track policy) {
    <div class="policy-item">
        <a
            class="policy-url"
            [attr.href]="policy.url"
            target="_blank">
            <p-button
                [label]="policy.name"
                [size]="'small'"
                [link]="true"
                [severity]="'secondary'" />
        </a>

        @if ($index < policies.length - 1) {
            •
        }
    </div>
}
